export const freeCheckoutMethodCode = 'free_checkout';
export const cashClubMethodCode = 'cashclub';

export const cartConfig = {
  maxQuantity: 300,
};

export enum QuantityChangeType {
  Increase,
  Decrease,
}
